'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import I18n from 'I18n';
import RadialData from './RadialData';
var oneSecond = 1000;
var lowThreshold = 5300;
var mediumThreshold = 7301;
var twentySeconds = 20000;
var twoHundred = 200;

var PageLoadingTimeRadialData = /*#__PURE__*/function (_RadialData) {
  _inherits(PageLoadingTimeRadialData, _RadialData);

  function PageLoadingTimeRadialData() {
    _classCallCheck(this, PageLoadingTimeRadialData);

    return _possibleConstructorReturn(this, _getPrototypeOf(PageLoadingTimeRadialData).apply(this, arguments));
  }

  _createClass(PageLoadingTimeRadialData, [{
    key: "init",
    value: function init(grade) {
      _get(_getPrototypeOf(PageLoadingTimeRadialData.prototype), "init", this).call(this, grade);

      var seconds = I18n.text('results.data.seconds');
      this.displayValueUnit = seconds;
      this.displayRecommendationValue = '< 5.3';
      this.displayRecommendationValueUnit = seconds;
    }
  }, {
    key: "setGradeType",
    value: function setGradeType(grade) {
      this.gradeType = this.getGoodOkBadGradeType(grade, lowThreshold, mediumThreshold);
    }
  }, {
    key: "setScore",
    value: function setScore(grade) {
      // E.g. 20 seconds = 100%, 1 second = 5%
      this.score = Math.round(Math.min(grade, twentySeconds) / twoHundred);
    }
    /**
     * Sets the displayValue and displayValueUnit.
     *
     * E.g.
     *
     *   grade = 5000
     *     displayValue = 5
     *     displayValueUnit = Sec
     *
     */

  }, {
    key: "setDisplayValue",
    value: function setDisplayValue(grade) {
      this.displayValue = Math.max(parseFloat((grade / oneSecond).toFixed(1)), 0.1);
    }
  }]);

  return PageLoadingTimeRadialData;
}(RadialData);

export default PageLoadingTimeRadialData;